import { connect } from 'react-redux'

import { selectSokETOResultat } from '../datafiltrering/datafiltreringSelector'
import { selectLoading } from '../midtdel/midtdelSelector'
import { selectSokRadEn, selectSokRadTo, selectSokRadTre } from '../raderogkolonner/raderOgKolonnerSelector'

import Krysstabell from './Krysstabell'

const mapStateToProps = (state) => ({
    dataSett: selectSokETOResultat(state),
    loading: selectLoading(state),
    sokRad1: selectSokRadEn(state),
    sokRad2: selectSokRadTo(state),
    sokRad3: selectSokRadTre(state)
})

export const KrysstabellContainer = connect(mapStateToProps, null)(Krysstabell)
